@if ((isLoading$ | async) || (hasError$ | async)) {
  <app-egg-spinner-overlay
  ></app-egg-spinner-overlay>
} @else {
  <app-header-nav-skeleton></app-header-nav-skeleton>
  <main
    class="be-container be-container--lg pt-8 md:pb-8 lg:py-12 flex flex-col lg:flex-row gap-7 lg:gap-16"
    >
    <section>
      <h2 class="titlev2 mb-5">You can now enroll in paperless statements</h2>
      <p
        id="paperlessBillingLabel"
        class="email-container be-text-sm text-navy-800"
        >
        Opt-in to have your loan statements for all accounts sent to:
        <button
          (click)="openEmailModal()"
          class="email-modal-btn flex gap-2 items-center mt-1"
          >
          <span class="underline font-medium">{{ profileEmail$ | async }}</span>
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
      </p>
      <form
        [formGroup]="paperlessForm"
        (ngSubmit)="updatePaperlessStatus()"
        class="mt-5 md:mt-8"
        >
        <mat-radio-group
          color="primary"
          aria-labelledby="paperlessBillingLabel"
          color="primary"
          class="flex flex-col gap-4"
          formControlName="isEnrolled"
          >
          <mat-radio-button class="radio-panel" [value]="true">
            Go paperless and have statements emailed to you
          </mat-radio-button>
          <mat-radio-button class="radio-panel" [value]="false">
            Continue receiving paper statements in the mail
          </mat-radio-button>
          @if (
            paperlessForm.controls.isEnrolled.invalid &&
            paperlessForm.controls.isEnrolled.touched
            ) {
            <app-be-helper-text
              class="flex justify-center sm:justify-end"
              [helperId]="beFormControlName + '-required'"
              helperType="error"
              >Please make a selection</app-be-helper-text
              >
            }
          </mat-radio-group>
          <div role="alert">
            @if (formSubmitStatus === 'error') {
              <app-notification
                variant="error"
                class="block mt-6 md:mt-8 mb-4 md:mb-6"
                >{{ submitError }}</app-notification
                >
              }
            </div>
            <div class="be-btn-group be-btn-group--right mt-6 md:mt-8 mb-4 md:mb-6">
              <a
                routerLink="/customer-hub"
                (click)="markPaperlessEnrollmentPageAsSeen()"
                class="link-responsive text-navy-tint-900 link-btn-ghost"
                >Maybe later</a
                >
                <app-api-btn
                  [isSubmitting]="formSubmitStatus === 'pending'"
                  [isDisabled]="formSubmitStatus === 'success'"
                  btnId="savePaperlessEnrollmentBtn"
                  >Save and continue</app-api-btn
                  >
                </div>
                <p
                  class="credit-card-enrollment-text be-text-sm text-navy-900 font-medium underline flex justify-center sm:justify-end"
                  >
                  <span
                    matTooltip="Enroll in paperless billing by navigating to your credit card profile."
                    matTooltipPosition="right"
                    class="flex gap-2 items-center"
                    >
                    <img src="assets/icons/info-icon.svg" alt="" />
                    <span>How do I enroll my credit card?</span>
                  </span>
                </p>
              </form>
            </section>
            <section class="paperless-bullet-panel">
              <img
                src="assets/icons/paperless-icon.svg"
                alt=""
                class="paperless-icon"
                />
              <h2 class="be-eyebrow-text text-navy-900 mb-6">Why go paperless?</h2>
              <ul class="flex flex-col gap-4">
                <li class="check-bullet-item be-text-xs font-medium">
                  <app-icon-circle-check
                    circleColor="#B8FF8D"
                    class="h-5 w-5 shrink-0"
                  ></app-icon-circle-check>
                  <span> Get your statements instantly </span>
                </li>
                <li class="check-bullet-item be-text-xs font-medium">
                  <app-icon-circle-check
                    circleColor="#B8FF8D"
                    class="h-5 w-5 shrink-0"
                  ></app-icon-circle-check>
                  <span>
                    Increase data security by reducing sensitive info sent via mail
                  </span>
                </li>
                <li class="check-bullet-item be-text-xs font-medium">
                  <app-icon-circle-check
                    circleColor="#B8FF8D"
                    class="h-5 w-5 shrink-0"
                  ></app-icon-circle-check>
                  <span> Reduce your environmental impact by saving paper </span>
                </li>
                <li class="check-bullet-item be-text-xs font-medium">
                  <app-icon-circle-check
                    circleColor="#B8FF8D"
                    class="h-5 w-5 shrink-0"
                  ></app-icon-circle-check>
                  <span> Eliminate the clutter of paper documents </span>
                </li>
              </ul>
            </section>
          </main>
          <app-simplified-footer></app-simplified-footer>
        }

